@if (showModule()) {
    <bs-linear-module-container [expandable]="true" [trackingBetslipTypeContext]="betslipType">
        <ng-template [bsLinearModuleHeader]>
            <bs-linear-bet-builder-header [betCount]="betCount()"></bs-linear-bet-builder-header>
        </ng-template>
        <ng-template [bsLinearModuleContent]>
            <bs-linear-bet-builder-content
                [picks]="picks()"
                [oddsDisplayFormat]="oddsDisplayFormat"
                [removeButtonStyle]="removeButtonStyle"></bs-linear-bet-builder-content>
        </ng-template>
    </bs-linear-module-container>
}
